export default class AnchoredScrollSection {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        // Execute the code below once the DOM is fully loaded
        window.addEventListener('DOMContentLoaded', () => {

            // Creates a new IntersectionObserver object, which is used to observe changes in the visibility of elements in the viewport as the user scrolls
            const observer = new IntersectionObserver(entries => {
                // Iterate through the entries array, which contains information about the elements being observed by the IntersectionObserver
                entries.forEach(entry => {
                    // For each observed element get the value of its id attribute and store it in the id variable
                    const id = entry.target.getAttribute('id');

                    // Check whether the observed element is currently visible on the screen,
                    // if so add the 'active' class to the corresponding navigation item, otherwise remove it
                    if (entry.intersectionRatio > 0) {
                        $(`.js-anchored-scroll-nav li a[href="#${id}"]`).parent().addClass('active');
                    } else {
                        $(`.js-anchored-scroll-nav li a[href="#${id}"]`).parent().removeClass('active');
                    }
                });
            });

            // Calculate the height of the anchored scroll navigation and store it in the navHeight variable
            const navHeight = $('.js-anchored-scroll-nav').outerHeight();

            // Track all sections that have an `id` applied
            document.querySelectorAll('section[id]').forEach((section) => {
                // For each section, set the minimum height to the previously calculated navHeight
                section.style.minHeight = navHeight+'px';
                // Monitor the visibility of each section as the user scrolls, and trigger the callback function when they enter or leave the viewport
                observer.observe(section);
            });

        });

    }

};

new AnchoredScrollSection();